import React from 'react'
import Button from '@material-ui/core/Button'
import { useAuth } from 'lib/auth'
import {
  getRegistrationClosedEffective,
  getRegistrationDisabled,
} from './registration-cta-utils'

const RegisterButton = ({
  groupEvent,
  paymentRequired,
  type,
  component,
  to,
}) => {
  const { user } = useAuth()
  const { isCanceled, registrationFull } = groupEvent

  const registrationClosedEffective = getRegistrationClosedEffective({
    user,
    groupEvent,
  })
  const registrationDisabled = getRegistrationDisabled({ user, groupEvent })

  const label = (() => {
    if (isCanceled) return 'Event Canceled'
    if (registrationClosedEffective) return 'Registration Closed'
    if (registrationFull) return 'Registration Full'
    if (paymentRequired) return 'Confirm and Pay'
    return 'Register'
  })()

  return (
    <Button
      variant="contained"
      color="primary"
      size="large"
      fullWidth
      disabled={registrationDisabled}
      {...{ type, component, to }}
    >
      {label}
    </Button>
  )
}

export default RegisterButton
